import { render, staticRenderFns } from "./CheckboxElement.vue?vue&type=template&id=744672e4&scoped=true&"
import script from "./CheckboxElement.vue?vue&type=script&lang=ts&"
export * from "./CheckboxElement.vue?vue&type=script&lang=ts&"
import style0 from "./CheckboxElement.vue?vue&type=style&index=0&id=744672e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744672e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VSwitch,VTooltip})
